import service from '../utils/request'

/**
 * 获取转换值列表
*/
export function getTransitionValue(data) {
    return service({
        headers: {
            'Authorization': localStorage.getItem('my_token')
        },
        method: 'post',
        url: '/assets/transition/GET',
        data
    })
}
// getTransitionValue() {
//     let data = [
//         'major_semester','gender'
//     ];
//     this.$post(
//         this.BASEURL + '/assets/transition/GET', {
//             'key_list': data
//         }).then((res) => {
//         if (res.code === 200) {
//             this.semester = res.data.major_semester[0];
//             this.semesterHash = res.data.major_semester[1];
//             this.genderData = res.data.gender[0]
//             this.genderHash = res.data.gender[1]
//         } else {
//             console.log(res.error);
//         }
//     });
// }
// getTblInfo(){
//     this.$post(this.BASEURL+'/assets/table/info',{
//         tbl_list:[['id','grade,name','major_base_t'],['org','org_name','academy_base_t']],
//         state:1
//     }).then((res)=>{
//         if(res.code === 200){
//             console.log('res.reeres.reeres.reeres.reeres.reeres.ree',res);
//             this.majorList = res.data[0][0]
//             this.majorHash = res.data[0][1]
//             this.orgList = res.data[1][0]
//             this.orgHash = res.data[1][1]
//         }else{
//             console.log(res.error);
//         }
//     })
// },
